module.exports = __webpack_public_path__ + "img/图片2.fe51e6df.png";